import { usePrivacySessionStore } from "./store";

export function usePrivacySession() {
  const expiresAt = usePrivacySessionStore((state) => state.expiresAt);
  const token = usePrivacySessionStore((state) => state.token);

  return { isUnlocked: Boolean(token && expiresAt && expiresAt > Date.now()), expiresAt };
}
